<!-- eslint-disable -->
<template>
	<div class="d-flex justify-content-center">
		<div
			class="d-flex flex-column rounded-lg border border-warning py-2 px-4"
			style="gap:0.25rem;max-width:320px;"
		>
			<div
				class="text-center text-gotham-bold"
				style="color: #FF434F;font-size: 16px;line-height: 20px;"
			>
				{{ language == "en" ? "Attention" : "Perhatian" }}:
			</div>
			<div style="line-height: 20px;">
				<span
					v-for="(step, index) in desc"
					:key="'warning' + index"
					:class="step.isBold ? 'text-gotham-bold' : ''"
				>
					{{ step.text }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	computed: {
		desc() {
			return [
				{
					text: this.language == "en" ? "This QR code can only be" : "Kode QR ini hanya dapat"
				},
				{
					text: this.language == "en" ? "scanned 1 (one) time." : "discan 1 (satu) kali saja.",
					isBold: true
				},
				{
					text: this.language == "en" ? "Make sure your items are" : "Pastikan barangmu"
				},
				{
					text:
						this.language == "en"
							? "stored in the locker before closing the door."
							: "sudah diambil dari loker sebelum menutup pintu.",
					isBold: true
				}
			];
		}
	}
};
</script>

<style scoped></style>
